import { render, staticRenderFns } from "./video-box.vue?vue&type=template&id=c7762314&scoped=true&lang=pug"
import script from "./video-box.vue?vue&type=script&lang=js"
export * from "./video-box.vue?vue&type=script&lang=js"
import style0 from "./templates/multimedia-box/multimedia-box.scss?vue&type=style&index=0&id=c7762314&prod&lang=scss&scoped=true&external"
import style1 from "./video-box.vue?vue&type=style&index=1&id=c7762314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7762314",
  null
  
)

export default component.exports